export function stringRemoveAllWhitespace(str: string): string {
  return str.replace(/\s+/g, "")
}
